import { useCallback } from 'react';
import PropTypes from 'prop-types';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';

import { DRAWER_WIDTH } from 'src/config';
import useInterface from 'src/hooks/useInterface';

import MiniDrawerStyled from './styled/MiniDrawerStyled';
import { CALL_STICKER_HEIGHT } from '../CallSticky/constants';

const MainDrawer = ({
	window,
	drawerOpen: drawerOpenProp,
	onCloseDrawer,
	DrawerHeaderRP,
	DrawerContentRP,
}) => {
	const { isDrawerOpen, isStickCall, onToggleDrawer } = useInterface();
	const drawerOpen =
		drawerOpenProp === undefined ? isDrawerOpen : drawerOpenProp;
	const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

	// responsive drawer container
	const container =
		window !== undefined ? () => window().document.body : undefined;

	const handleDrawerClose = useCallback(() => {
		if (onCloseDrawer) {
			onCloseDrawer();
		} else {
			onToggleDrawer(false);
		}
	}, [onCloseDrawer, onToggleDrawer]);

	return (
		<Box
			component="nav"
			sx={{
				flexShrink: { md: 0 },
				zIndex: 1200,
				transition: '.5s height',
				' .MuiPaper-root': {
					top: isStickCall ? CALL_STICKER_HEIGHT : 0,
					transition: '.2s top',
				},
			}}
			aria-label="mailbox folders"
		>
			{!downLG ? (
				<MiniDrawerStyled variant="permanent" open={drawerOpen}>
					{DrawerHeaderRP && <DrawerHeaderRP drawerOpen={drawerOpen} />}
					{DrawerContentRP && <DrawerContentRP />}
				</MiniDrawerStyled>
			) : (
				<Drawer
					container={container}
					variant="temporary"
					open={drawerOpen}
					onClose={handleDrawerClose}
					ModalProps={{ keepMounted: true }}
					sx={{
						display: { xs: drawerOpen ? 'block' : 'none', lg: 'none' },
						'& .MuiDrawer-paper': {
							boxSizing: 'border-box',
							width: DRAWER_WIDTH,
							borderRight: '1px solid',
							borderRightColor: 'divider',
							backgroundImage: 'none',
							boxShadow: 'inherit',
						},
					}}
				>
					{DrawerHeaderRP && <DrawerHeaderRP drawerOpen={drawerOpen} />}
					{DrawerContentRP && <DrawerContentRP />}
				</Drawer>
			)}
		</Box>
	);
};

MainDrawer.propTypes = {
	window: PropTypes.func,
	drawerOpen: PropTypes.bool,
	onCloseDrawer: PropTypes.func,
	DrawerHeaderRP: PropTypes.elementType,
	DrawerContentRP: PropTypes.elementType,
};

export default MainDrawer;
